<template>
  <div>
    <mt-popup
      v-model="popupVisible"
      :position="position"
      :lockScroll="true"
      :closeOnClickModal="false"
      class="popupBox"
      :style="isSmallPCSize ? { height: '506px'} : ''"        
    >
      <div class="info_box">
        <!-- top -->
        <div class="top_title">
          <i class="icon-outline_close" @click="handleClick(false)"></i>
        </div>
        <!-- content -->
        <div 
          class="content"
          :class="edit ? '' : 'content_style'"
          :style="isSmallPCSize ? 
            (edit ? { height: '385px'}  :  { height: '440px'})
            : ''"  
        >
          <EvaluateWelcome class="pc" :userName="phone" />
          <div class="h5_info_box">
            <div class="eva_1">
              <EvaluateProblem
                :problem="shopProblem"
                :info="SHOP_INFO.shopName"
                :img="SHOP_INFO.shopImg"
              />
            </div>
            <EvaluateStar
              :scoreInfo="shopScoreInfo"
              :edit="edit"
              :seeDesc="seeDesc"
              :starScore="edit ? shopScore : seeShopScore"
              @on-change-star="changeShopStar"
            />
            <div class="eva_2" v-show="isShowShopListTag && shopTags.length">
              <EvaluateTags
                :edit="edit"
                :list="shopTags"
                @on-change-tags="changeShopTags"
              />
            </div>
            <div 
              class="eva_textarea evaluate-textarea-wrapper"
              :style="(isShowShopListTag && shopTags.length) ? '' : {
                marginTop: '10px'
              }"
              v-show="isShowShopCont || seeShopContent"
            >
              <el-input
                class="input_style"
                v-show="isShowShopCont"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10}"
                :placeholder="$t('更多评价')"
                v-model="shopContent"
                maxlength="1000"
                show-word-limit
              />
              <p class="contentInfo" v-if="seeShopContent">
                {{ seeShopContent }}
              </p>
            </div>
          </div>

          <div class="h5_info_box mt20">
            <div class="eva_3">
              <EvaluateProblem
                :problem="riderProblem"
                :info="RIDER_INFO.riderName"
                :img="RIDER_INFO.riderImg"
              />
            </div>
            <EvaluateFace
              :edit="edit"
              :seeRiderScore="seeRiderScore"
              :seeRiderDesc="seeRiderDesc"
              :scoreInfo="riderScoreInfo"
              @on-change-face="changeRiderFace"
            />
            <div class="eva_4" v-show="isShowRiderTags && riderTags.length">
              <EvaluateTags
                :edit="edit"
                :list="riderTags"
                @on-change-tags="changeRiderTags"
              />
            </div>
            <div 
              class="eva_textarea evaluate-textarea-wrapper"
              :style="(isShowRiderTags && riderTags.length) ? '' : {
                marginTop: '10px'
              }"
            >
              <el-input
                class="input_style"
                v-show="isShowRiderCont"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10}"
                :placeholder="$t('更多评价')"
                v-model="riderContent"
                maxlength="1000"
                show-word-limit
              />
              <p class="contentInfo" v-if="seeRiderContent">
                {{ seeRiderContent }}
              </p>
            </div>
          </div>
        </div>
        <!-- footer -->
        <div class="footer">
          <el-button
            v-if="edit"
            class="btn"
            :disabled="disabledBtn"
            :loading="loading"
            @click="clickBtn"
            >{{$t('提交')}}</el-button
          >
        </div>
      </div>
    </mt-popup>
    <EvaluateAlert
      v-if="isShowAlert"
      :content="$t('退出页面后，当前评价会全部丢失，确认退出吗？')"
      @close="isShowAlert = false"
      @ok="handleClick(true)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EvaluateWelcome from '@/components/Evaluate/welcome.vue';
import EvaluateProblem from '@/components/Evaluate/problem.vue';
import EvaluateStar from '@/components/Evaluate/star.vue';
import EvaluateTags from '@/components/Evaluate/tags.vue';
import EvaluateFace from '@/components/Evaluate/face.vue';
import EvaluateAlert from '@/components/Evaluate/alert.vue';

const SHOP_FULL_MARK = 500; // 店铺好评
const RIDER_FULL_MARK = 10; // 骑手好评

export default {
  name: 'Evaluate',
  components: {
    EvaluateWelcome,
    EvaluateProblem,
    EvaluateStar,
    EvaluateTags,
    EvaluateFace,
    EvaluateAlert,
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: 'center',
    },
    orderId: {
      type: String,
    },
    status: {
      type: Number,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    outScore: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    outScore: {
      handler: function(newScore) {
        this.shopScore = newScore;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      clientHeight: ({ common }) => common.clientHeight,
      sidebar: ({ common }) => common.sidebar,
      evaTagList: ({ order }) => order.evaTagList,
      evaInfo: ({ order }) => order.evaInfo,
    }),
    isSmallPCSize() {
      if (!this.isH5 && this.clientHeight && this.clientHeight < 650) {
        return true
      }

      return false
    },
    // common
    phone() {
      return this.sidebar?.selfInfo?.phone;
    },
    // 按钮是否可点击
    disabledBtn() {
      return +this.shopScore === 0 || this.shopScore === undefined;
    },
    shopProblem() {
      return this.edit ? this.$t('您对商家满意吗？') : this.$t('商家评价');
    },
    riderProblem() {
      return this.edit ? this.$t('您对骑手满意吗？') : this.$t('骑手评价');
    },
    // 商家信息
    SHOP_INFO() {
      if (this.edit) {
        return this.evaTagList?.shop || {};
      }
      return this.evaInfo?.shop || {};
    },
    // 骑手信息
    RIDER_INFO() {
      if (this.edit) {
        return this.evaTagList?.rider || {};
      }
      return this.evaInfo?.rider || {};
    },
    // shop
    shopScoreInfo() {
      if (this.edit) {
        return this.evaTagList?.shop?.scoreInfo;
      }
      return [
        { score: 100 },
        { score: 200 },
        { score: 300 },
        { score: 400 },
        { score: 500 },
      ];
    },
    shopTags() {
      if (this.edit) {
        return this.evaTagList?.shop?.badTag;
      }
      return this.evaInfo?.shop?.tags;
    },
    isShowShopListTag() {
      if (this.edit) {
        return this.shopScore !== 0 && this.shopScore < 500;
      }
      return true;
    },
    isShowShopCont() {
      if (this.edit) {
        return this.shopScore !== 0;
      }
      return false;
    },
    seeShopScore() {
      return this.evaInfo?.shop?.score;
    },
    seeDesc() {
      if (this.edit) {
        return '';
      }
      return this.evaInfo?.shop?.scoreDesc;
    },
    seeShopContent() {
      if (this.edit) {
        return false;
      }
      return this.evaInfo?.shop?.content;
    },
    // rider
    riderScoreInfo() {
      return this.evaTagList?.rider?.scoreInfo;
    },
    isShowRiderTags() {
      if (this.edit) {
        return this.riderScore !== 0 && this.riderScore < 3;
      }
      return true;
    },
    seeRiderScore() {
      return this.evaInfo?.rider?.score;
    },
    seeRiderDesc() {
      return this.evaInfo?.rider?.scoreDesc;
    },
    riderTags() {
      if (this.edit) {
        return this.evaTagList?.rider?.badTag;
      }
      return this.evaInfo?.rider?.tags;
    },
    isShowRiderCont() {
      if (this.edit) {
        return this.riderScore !== 0;
      }
      return false;
    },
    seeRiderContent() {
      if (this.edit) {
        return false;
      }
      return this.evaInfo?.rider?.content;
    },
  },
  data() {
    return {
      isShowAlert: false,
      loading: false,
      shopScore: 0, // 店铺评分
      shopDesc: '', // 店铺评分描述
      shopTagIds: [], // 店铺评价标签
      shopContent: '',
      riderScore: 0, // 骑手评分
      riderTagIds: [], // 骑手评价标签
      riderContent: '',
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('order', ['postEvaInfo']),
    init() {
      this.$trackEvent({
        eventId: 'sailing_c_x_orderpage_evaluate_sw',
        eventLabel: '评价卡片曝光',
        attrs: {
          order_id: this.orderId,
          order_status: this.status,
          evaluation_status: this.edit ? 1 : 2,
        },
      });
    },
    // 设置店铺评分
    setShopScore(data = 0) {
      this.shopScore = data
    },
    // 关闭弹窗
    handleClick(tag = false) {
      if (tag) {
        this.isShowAlert = false;
        this.$emit('on-close');
        return;
      }
      if (this.shopScore > 0) {
        // 二次确认
        this.isShowAlert = true;
      } else {
        this.$emit('on-close');
      }
    },
    // 选择商家星星
    changeShopStar(item) {
      this.shopScore = item.score;
      this.shopDesc = item.desc;
    },
    // 选择商铺评价标签
    changeShopTags(data) {
      this.shopTagIds = data;
    },
    // 选择骑手笑脸
    changeRiderFace(items) {
      this.riderScore = items.score;
    },
    // 选择骑手标签
    changeRiderTags(data) {
      this.riderTagIds = data;
    },
    // 提交评价
    async clickBtn() {
      this.loading = true;

      const obj = {
        orderId: this.orderId,
        shop: JSON.stringify({
          score: this.shopScore,
          tagIds: +this.shopScore === SHOP_FULL_MARK ? [] : this.shopTagIds,
          content: this.shopContent,
        }),
        rider: JSON.stringify({
          score: this.riderScore,
          tagIds: +this.riderScore === RIDER_FULL_MARK ? [] : this.riderTagIds,
          content: this.riderContent,
        }),
      };

      await this.postEvaInfo(obj);
      this.loading = false;

      this.$emit('on-success', {
        orderId: this.orderId,
        shopDesc: this.shopDesc,
        shopScore: this.shopScore,
        riderScore: this.riderScore,
      });

      this.$trackEvent({
        eventId: 'sailing_c_x_evaluation_submit_ck',
        eventLabel: '评价卡片confirm点击',
        attrs: {
          order_id: this.orderId,
          order_status: this.status,
          restaurant_rating: this.shopScore,
          delivery_evaluation: this.riderScore,
        },
      });
    },
  },
};
</script>

<style lang="scss">
// input 样式
.evaluate-textarea-wrapper {
  .el-textarea__inner {
    padding: 12px;
    min-height: 90px;
    line-height: 18px;
    font-family: 'Aspira Light';
    font-size: 14px;
    color: #000000;
    border-color: #E5E5E5;
    background: #fff;
    caret-color: #ff7a45;
  }
  .el-textarea__inner:focus {
    background: #F5F5F7;
  }
  // .el-textarea__inner:focus~.el-input__count {
  //   color: #ff4e45;
  // }
  .el-textarea__inner::-webkit-input-placeholder { 
    color: #ccc; 
  }
  .el-input__count {
    font-size: 12px;
    color: #CCCCCC;
    background: none
  }
}
</style>

<style lang="scss" scoped>
.pc {
  display: block;
}

.eva_textarea {
  padding-top: 0;
}

.popupBox {
  width: 470px;
  height: 656px;
  border-radius: 8px;
  background-color: #fff;
  font-family: 'Aspira Light';
  font-weight: 200;
  .info_box {
    position: relative;
    height: 100%;
  }
  .content {
    height: 535px;
    overflow-y: auto;
    padding: 0 24px;
    padding-bottom: 80px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-weight: normal;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    &.content_style {
      height: 580px;
    }
  }
  .top_title {
    position: relative;
    height: 60px;
    i {
      cursor: pointer;
      position: absolute;
      left: 27px;
      top: 27px;
      font-size: 22px;
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 20px 20px 20px;
  .btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-family: 'Aspira Medium';
    font-weight: 500;
  }
}

.eva_1 {
  margin-top: 32px;
  margin-bottom: 10px;
}
.eva_2 {
  margin-top: 20px;
  margin-bottom: 10px;
}
.eva_3 {
  margin-top: 48px;
  margin-bottom: 10px;
}
.eva_4 {
  margin-top: 25px;
  margin-bottom: 10px;
}
.contentInfo {
  position: relative;
  padding: 0 8px;
  padding-top: 10px;
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 14px;
  color: #000;
  z-index: 2;
  word-break: break-all;
  word-wrap: break-word;
  &::before {
    position: absolute;
    left: 0;
    top: 18px;
    color: #666;
    opacity: 0.08;
    content: "“";
    font-size: 66px;
    z-index: 1;
  }
  &::after {
    position: absolute;
    right: 0;
    bottom: -38px;
    color: #666;
    opacity: 0.08;
    content: "”";
    font-size: 66px;
    z-index: 1;
  }
}

.input_style {
  font-family: 'Aspira Light';
  font-weight: 200;
}

// 移动端适配
@media screen and (max-width: 768px) {
  .pc {
    display: none;
  }
  .input_style ::v-deep textarea {
    -webkit-appearance: none;appearance: none;
  }

  .popupBox {
    width: 100%;
    height: 88%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #f5f5f7;
    .content {
      height: 80%;
      overflow-y: auto;
      padding: 0 rem(24);
      padding-bottom: rem(100);
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: 14px;
      color: #000;
      line-height: 20px;
      &.content_style {
        height: 72vh;
      }
    }
  }

  .eva_textarea {
    margin: 0 rem(32);
  }

  .h5_info_box {
    background: #fff;
    border-radius: 12px;
    padding: rem(48) 0;
  }
  .mt20 {
    margin-top: rem(20);
  }

  .eva_1 {
    margin-top: 0;
    margin-bottom: rem(50);
  }
  .eva_3 {
    margin-top: 0;
    margin-bottom: rem(60);
  }

  .contentInfo {
    font-size: rem(28);
    font-family: 'Aspira Light';
    font-weight: 200;
    margin-bottom: rem(20);
  }
}
</style>
